<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>未付费与付费体力人数占比</span>
    </div>
    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          size="mini"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          size="mini"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="类型" prop="level">
        <el-select v-model.number="queryParams.level" size="mini" placeholder="请选择">
          <el-option
            v-for="item in payArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="等级" prop="id">
        <el-select v-model.number="queryParams.id" size="mini" placeholder="请选择">
          <el-option
            v-for="item in titleArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="loading" icon="el-icon-search" size="mini" @click="handleQuery()">查询</el-button>
        <el-button type="primary" :loading="loading" size="mini" @click="exportData()">导出</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="24">
      <userSpinRateChart ref="rateNotPay" />
    </el-row>
  </el-card>
</template>
<script>
import userSpinRateChart from '@/views/config/spins-consume/compents/user-spin-rate-chart.vue'
import { getLastDates } from '@/utils'
import { getUserSpinsRate } from '@/api/statistics/user_remain'

export default {
  components: {
    userSpinRateChart
  },
  data() {
    return {
      loading: false,
      title: '未付费',
      tableData: [],
      titleArr: [
        { label: '全部', value: -1 },
        { label: '<5', value: 1 },
        { label: '5-10', value: 2 },
        { label: '11-30', value: 3 },
        { label: '31-70', value: 4 },
        { label: '>70', value: 5 }
      ],
      payArr: [
        { label: '全部', value: 0 },
        { label: '免费', value: 1 },
        { label: '付费', value: 2 }
      ],
      queryParams: {
        startDate: '',
        endDate: '',
        level: 0,
        id: -1,
        type: 1
      }
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
  },
  mounted() {
    this.getTables()
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }
      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }
      this.getTables({})
    },
    getTables() {
      this.queryParams.type = 0
      this.$refs.rateNotPay.refresh(1, this.queryParams)
    },
    exportData() {
      this.queryParams.type = 1
      this.queryParams.Id = 0
      getUserSpinsRate(this.queryParams).then(res => {
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }
}

</script>

<style scoped>

</style>
